// Candidate only: Task Report summaries do not contain a submission reference.
// The authorized backend menu-open lookup decides final eligibility.
export const canOfferTaskExcelAction = (task, canManageTasks, completeTimingFlag) => Boolean(
   canManageTasks && task && Number.isSafeInteger(Number(task.noTask)) && Number(task.noTask) > 0 &&
   (task.timingState & completeTimingFlag) === completeTimingFlag
);
